import axios from 'axios'
import store from '../store'
import { URL } from '../const'

import {
  RESET_DETAILS,
  FETCHING_DETAILS,
  FETCH_DETAILS_SUCCESS,
  FETCH_DETAILS_FAIL,
  SHOW_TOAST,
  HIDE_TOAST
} from '../actions/types'

export const fetchDetails = (category, id) => async dispatch => {
  dispatch({ type: FETCHING_DETAILS })
  // console.log('fetching data')
  const headers = {
    'Authorization': `Token ${store.getState().user.token}`
  }
  const url = `${URL}${category}/${id}`
  try {
    const res = await axios.get(
      url,
      { headers }
    )
    // console.log('res: ', res)
    dispatch({
      type: FETCH_DETAILS_SUCCESS,
      payload: {
        data: res.data.item,
        category: category
      }
    })
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: FETCH_DETAILS_FAIL })
  }
}

export const resetDetails = () => {
  return {
    type: RESET_DETAILS
  }
}

export const deleteDetails = (category, id, redirect) => async dispatch => {
  const headers = {
    'Authorization': `Token ${store.getState().user.token}`
  }
  const url = `${URL}${category}?id=${id}`
  try {
    const res = await axios.delete(
      url,
      { headers }
    )
    console.log('res: ', res)
    if (redirect) {
      redirect()
    }
    showToast(dispatch, '削除しました', 'danger')
  } catch (error) {
    console.log('error: ', error)
    showToast(dispatch, '削除失敗しました！！', 'danger')
  }
}

const showToast = function (dispatch, toastMessage, toastColor) {
  console.log('show')
  dispatch({
    type: SHOW_TOAST,
    payload: {
      toastMessage,
      toastColor
    }
  })

  setTimeout(() => {
    console.log('timeout')
    dispatch({ type: HIDE_TOAST })
  }, 3000)
}



// WEBPACK FOOTER //
// ./src/actions/detailsActions.js